import React from 'react';
import cn from 'classnames';
import { LazyImage, Title, Subtitle, Icon } from '@landing/ui';
import { Tag } from 'components/UI';

import * as styles from './Card.module.scss';

export default function Card({
  title,
  titleTag = 'h3',
  titleMarker,
  subtitle,
  description,
  list,
  count,
  icon,
  imgSrc,
  link,
  linkTitle,
  className,
  additionalItems,
  onClick,
  theme,
}) {
  return (
    <div className={cn(className, styles.item, theme && styles[theme])}>
      {imgSrc && <LazyImage className={styles.icon} src={imgSrc} alt={title} />}
      {count && <div>{count}</div>}
      {icon && <Icon name={icon} className={styles.icon} />}
      <Title tag={titleTag} size="h3" className={styles.title} color={theme}>
        {titleMarker && (
          <Tag className={styles.titleMarker} mods="numberMarker">
            {titleMarker}
          </Tag>
        )}
        {title}
      </Title>
      {subtitle && <Subtitle color={theme}>{subtitle}</Subtitle>}
      {description && (
        <Subtitle className={styles.description} color={theme}>
          {description}
        </Subtitle>
      )}
      {list && (
        <ul className={styles.list}>
          {list.map(item => (
            <li key={item} className={styles.listItem}>
              <h4 className={styles.listItemTitle}>{item}</h4>
            </li>
          ))}
        </ul>
      )}
      {linkTitle && (
        <a className={cn(styles.link)} href={link}>
          {linkTitle}
        </a>
      )}
      {onClick && additionalItems && (
        <button className={styles.button} onClick={onClick}>
          See more
        </button>
      )}
    </div>
  );
}
